import $ from "jquery";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  registerUser,
  registerUserLinkedin,
  proceedToLogin,
} from "SignupActions";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { showLoading, hideLoading } from "react-redux-loading-bar";
//import LinkedIn from 'react-linkedin-login';
import LoginErrorBar from "./../errorbar";
import { clearCache } from "SignupActions";
class SignupCreate extends Component {
  constructor(props) {
    super(props);

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
    this.callbackLinkedIn = this.callbackLinkedIn.bind(this);

    this.state = {
      showAlert: false,
      alertMessage: "",
      alertTitle: "Error",
      terms: true,
    };
  }

  componentDidMount() {
    if (!this.props.fromLogin) {
      this.props.clearCache();
    }
  }

  callbackLinkedIn(response) {
    this.props.registerUserLinkedin(response.code, (response) => {
      if (response.success === 0) {
        this.setState({
          ...this.state,
          showAlert: true,
          alertMessage: response.message,
        });
      }
    });
  }

  onChangeCheckbox(event) {
    this.setState({ ...this.state, terms: event.target.checked });
  }

  hideAlert() {
    this.setState({ ...this.state, showAlert: false });
  }

  renderField(field) {
    var {
      meta: { touched, error },
    } = field;
    var className = `form-group signup-element ${
      touched && error ? "has-danger" : ""
    }`;
    return (
      <div className={className}>
        <label>{field.label}</label>
        <input
          className="form-control"
          type={field.type}
          placeholder={field.placeholder}
          {...field.input}
          disabled={field.disabled}
        />
        <div className="text-help">{touched ? error : ""}</div>
      </div>
    );
  }

  onFormSubmit(values) {
    // debugger;
    if (this.state.terms) {
      this.props.showLoading();
      this.props.registerUser(
        values,
        this.props.session,
        this.props.user,
        (response) => {
          this.props.hideLoading();

          if (response.success === 1) {
          } else {
            var error = response.message.response.data.error.context.email[0];

            this.setState({
              ...this.state,
              showAlert: true,
              alertMessage: error,
            });
            setTimeout(() => {
              this.setState({ ...this.state, showAlert: false });
              this.props.proceedToLogin();
            }, 3000);
          }
        }
      );
    } else {
      this.setState({
        ...this.state,
        showAlert: true,
        alertMessage: "Please accept terms & conditions before proceeding",
      });
      setTimeout(
        () => this.setState({ ...this.state, showAlert: false }),
        3000
      );
    }
  }

  render() {
    var { handleSubmit } = this.props;
    return (
      <div>
        {this.state.showAlert ? (
          <LoginErrorBar
            style={{ top: "-30px" }}
            alertMessage={this.state.alertMessage}
          />
        ) : (
          ""
        )}
        <form
          onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
          className="steps-animation"
        >
          <div className="clearfix">&nbsp;</div>
          <Field
            name="email"
            label="Email"
            placeholder="Email address"
            type="email"
            component={this.renderField}
          />

          {this.props.session.sessionToken && this.props.signupChangeEmail ? (
            ""
          ) : (
            <Field
              name="password"
              label="Password"
              placeholder="Set a password"
              type="password"
              component={this.renderField}
            />
          )}
          <div className="checkbox checkbox-primary signup-element signup-multi-color">
            <input
              type="checkbox"
              onChange={this.onChangeCheckbox}
              checked={this.state.terms}
              disabled={this.props.session.sessionToken !== ""}
            />
            <label>
              {"By signing up you're agreed to our"}{" "}
              <Link to="/terms">Terms & Conditions</Link>
            </label>
          </div>
          <div className="form-group">
            <button type="submit" className="btn btn-default btn-social-login">
              {this.props.session.sessionToken && this.props.signupChangeEmail
                ? "Update Email"
                : "Create Account"}
            </button>
          </div>
          {/*<div className="form-group horizontal-align-center login-light-color">
            or signup with
          </div>
          <div className="form-group horizontal-align-center">
            <LinkedIn
              clientId='81bvt77dsq614p'
              callback={this.callbackLinkedIn}
              scope={["r_emailaddress"]}
              className="btn btn-link-social btn-link-social-linkedin">
              <i className="fa fa-linkedin"/>
            </LinkedIn>
        <Link to="/signup/twitter">
        <span className="btn btn-link-social btn-link-social-twitter">
          <i className="fa fa-twitter"></i>
        </span>
      </Link>
      <Link to="/signup/google">
      <span className="btn btn-link-social btn-link-social-google-plus">
        <i className="fa fa-google-plus"></i>
      </span>
    </Link>
  </div>*/}
          <div className="form-group horizontal-align-center login-multi-color">
            Already have an account? <Link to="/login">Login</Link>
          </div>
        </form>
      </div>
    );
  }
}

function validate(values) {
  var errors = {};

  if (!values.email) {
    errors.email = "Please enter an email address!";
  }
  if (!values.password) {
    errors.password = "Please provide a password!";
  }

  return errors;
}

function mapStateToProps({ session, signupChangeEmail, user }) {
  return { session, user, signupChangeEmail };
}

export default reduxForm({
  validate,
  form: "SignupForm",
})(
  connect(mapStateToProps, {
    registerUser,
    showLoading,
    hideLoading,
    registerUserLinkedin,
    proceedToLogin,
    clearCache,
  })(SignupCreate)
);
